import { inject, observer } from 'mobx-react';
import React, { Component } from 'react'
import { ReactComponent as LockIcon } from '../../svg/lock-icon.svg'
import { ReactComponent as LockIconLocked } from '../../svg/lock-icon-locked.svg'

@inject('workAreaStore', 'errorStore') @observer
class SizeInput extends Component {

  constructor(props){
    super(props)
    this.state = {
      width: 0,
      height: 0,
      locked: false,
      oldWidth: 0,
      oldHeight: 0,
      aspectW: 0,
      aspectH: 0
    }
  }

  componentDidMount(){
    const { width, height } = this.props
    this.setState({
      width,
      height,
      aspectW: width / height,
      aspectH: height / width,
      oldHeight: height,
      oldWidth: width
    })
  }

  calculateAspectRatio(newValue, widthChange){
    const { aspectH, aspectW, oldWidth, oldHeight } = this.state
    if(widthChange){
      let aspect = aspectW
      if(aspectH > aspectW){
        aspect = aspectH
      }
      let newHeight = newValue / aspect
      if(oldHeight > oldWidth){
        newHeight = newValue * aspect
      }
      this.setState({
        height: isNaN(newHeight) ? 1 / aspect : Math.round(newHeight)
      })
    }else{
      let aspect = aspectW
      if(aspectH < aspectW){
        aspect = aspectH
      }
      let newWidth = newValue / aspect
      if(oldWidth < oldHeight){
        newWidth = newValue * aspect
      }
      this.setState({
        width: isNaN(newWidth) ? 1 / aspect : Math.round(newWidth)
      })
    }
  }
  
  handleChange(e){
    const { value, name } = e.target
    const oldWidth = this.state.width
    const oldHeight = this.state.height
    this.setState({
      [name]: value
    })
    if(this.state.locked && Number(value) >= 1){
      this.setState({
        oldHeight,
        oldWidth
      })
      this.calculateAspectRatio(Number(value), name === 'width')
    }
  }

  toggleLock(e){
    e.preventDefault()
    e.stopPropagation()
    this.setState({
      locked: !this.state.locked,
      aspectW: this.state.width / this.state.height,
      aspectH: this.state.height / this.state.width
    })
  }

  save(){
    this.props.errorStore.setErrorMessage('Design size updated', false)
    this.props.save(this.state.width, this.state.height)
  }

  render(){
    return (
      <div className='design-menu__custom-size'>
        <h5>Set a custom size</h5>
        <div className='design-menu__inputs'>
          <div className='design-menu__input-group'>
            <label className='gray'>Width</label>
            <input
              className='form-control'
              type='number'
              onChange={e => this.handleChange(e)}
              name='width'
              value={this.state.width}
            />
          </div>
          <div className='design-menu__lock-ratio' onClick={e => this.toggleLock(e)}>
            {
              this.state.locked ? <LockIconLocked style={{fill: 'none'}}/> : <LockIcon style={{fill: 'none'}} />
            }
          </div>
          <div className='design-menu__input-group' style={{marginRight: '10px'}}>
            <label className='gray'>Height</label>
            <input
              className='form-control'
              type='number'
              onChange={e => this.handleChange(e)}
              name='height'
              value={this.state.height}
            />
          </div>
          <div className='design-menu__type'>
            <span>px</span>
          </div>
        </div>
        <div className='design-menu__update-size'>
          <button className='btn btn-danger' onClick={() => this.save()}>
            Update size
          </button>
        </div>
      </div>
    )
  }

}

export default SizeInput